// P1B-FE — NVR topology tree (Site → Node/SLink agent → Source/NVR → channels).
import { useQuery } from "@tanstack/react-query";

import { api } from "./client";

export interface TopologyChannel {
  camera_logical_id: string;
  channel_no: number;
  name: string;
  is_provisional: boolean;
  live: boolean;
}
export interface TopologySource {
  id: string;
  host: string; // NVR host only — never a credentialed URL
  port: number;
  protocol: string;
  channel_count: number;
  channels: TopologyChannel[];
}
export interface TopologyNode {
  id: string;
  name: string;
  agent_id: string | null;
  agent_name: string | null;
  sources: TopologySource[];
}
export interface TopologySite {
  id: string;
  name: string;
  nodes: TopologyNode[];
}
export interface TopologyResponse {
  sites: TopologySite[];
}

export function useTopology() {
  return useQuery({
    queryKey: ["topology"] as const,
    queryFn: async () => {
      const { data } = await api.get<TopologyResponse>("/api/v1/topology");
      return data;
    },
  });
}
